<template>
  <div>
    <wo-region v-show="exactRoute">
      <wo-layout v-if="tab">
        <wo-title tag-name="h2" v-t="'reco.title'"></wo-title>
        <po-tabs :tabs="tabs" v-model="tab" />
        <wo-grid>
          <wo-column width-lg="4">
            <reco-text-search v-if="isSimpleSearch" v-model="types" :action="tab" :country="country" />
            <reco-browse v-else v-model="types" />
          </wo-column>
          <wo-column width-lg="8">
            <reco-type-list v-if="types" :value="types" @select="select" />
            <po-empty-state v-else labelKey="reco.noSearch" v-wo-align:center />
          </wo-column>
        </wo-grid>
      </wo-layout>
    </wo-region>
    <router-view v-if="!exactRoute" />
  </div>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import { isRouteMatch } from '@/util'

import { RECO_SEARCH, RECO_TYPE } from '@/routes/product'

import { recoCapabilitiesRepository } from '@/repository/reco'

import RecoTypeList from '@/components/reco/RecoTypeList'
import RecoTextSearch from '@/components/reco/RecoTextSearch'
import RecoBrowse from '@/components/reco/RecoBrowse'

import { RecoCapabilityActionEnum } from '@/model/reco'

const supported = RecoCapabilityActionEnum.values

export default {
  components: { RecoTypeList, RecoTextSearch, RecoBrowse },
  props: {
    type: String
  },
  data () {
    return {
      searchText: undefined,
      tab: undefined,
      types: undefined
    }
  },
  computed: mapState({
    currentUser: state => state.identity.currentUser,
    capabilities: state => state.reco.recoCapabilities,
    tabs () {
      return _.filter(this.capabilities.actions, t => {
        return _.includes(supported, t) && (!t.country || this.country)
      })
    },
    country () {
      return this.capabilities.resolveCountry(this.currentUser)
    },
    exactRoute () {
      return isRouteMatch(this.$route, RECO_SEARCH)
    },
    isSimpleSearch () {
      return !!this.tab.prop
    }
  }),
  created () {
    this.loadCapabilities()
  },
  watch: {
    type () {
      this.ensureTab()
    },
    tab () {
      this.tab && this.$router.push({ name: RECO_SEARCH, params: { type: this.tab.id } })
    }
  },
  methods: {
    loadCapabilities () {
      this.$store.dispatch(recoCapabilitiesRepository.find)
        .then(this.ensureTab)
    },
    ensureTab () {
      const tab = _.find(this.tabs, t => t.id === this.type)
      this.tab = tab || this.tabs[0]
    },
    select (type) {
      this.$router.push({ name: RECO_TYPE, params: { typeId: type.id, searchId: type.search_id } })
    }
  }
}
</script>`
